if (!customElements.get('cart-drawer-upsell-button')) {
  customElements.define(
    'cart-drawer-upsell-button',
    class CartDrawerUpsellButton extends HTMLElement {
      constructor() {
        super();
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
      }

      connectedCallback() {
        this.button = this.querySelector('.upsell-add-button');
        if (!this.button) return;

        this.button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.addToCart(this.button);
        });
      }

      async addToCart(button) {
        if (button.disabled || button.classList.contains('adding')) return;

        const variantId = button.getAttribute('data-variant-id');
        const originalText = button.textContent.trim();

        button.classList.add('adding');
        button.disabled = true;
        button.textContent = '\u2022\u2022\u2022';

        try {
          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', '1');

          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(button);
          }

          const config =
            typeof fetchConfig === 'function'
              ? fetchConfig('javascript')
              : { method: 'POST', headers: {} };
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = formData;

          const res = await fetch(
            window.routes?.cart_add_url || '/cart/add.js',
            config
          );
          const response = await res.json();

          if (response.status) {
            throw new Error(response.description || 'Could not add to cart');
          }

          button.classList.remove('adding');
          button.classList.add('added');
          button.textContent = '\u2713';

          if (
            typeof publish === 'function' &&
            typeof PUB_SUB_EVENTS !== 'undefined'
          ) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-drawer-upsell',
              productVariantId: variantId,
              cartData: response,
            });
          }

          if (this.cart) {
            this.cart.renderContents(response);
          }

          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }

          setTimeout(() => {
            button.textContent = originalText;
            button.classList.remove('added');
            button.disabled = false;
          }, 1800);
        } catch (err) {
          console.error('Cart drawer upsell error:', err);
          button.classList.remove('adding');
          button.classList.add('error');
          button.textContent = '\u2717';

          setTimeout(() => {
            button.textContent = originalText;
            button.classList.remove('error');
            button.disabled = false;
          }, 1800);
        }
      }
    }
  );
}
